import React from 'react';

export default ({ style, color = 'black' }) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    viewBox="-156 170 90 90"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill={color}
        d="M-115.7,181.7v2h-3.3v49.9c0,7.2-5.9,13.1-13.1,13.1h-0.1c-7.2,0-13.1-5.9-13.1-13.1v-49.9h-3.3v-2H-115.7 M-115.7,178.7   h-33c-1.7,0-3,1.3-3,3v2c0,1.7,1.3,3,3,3h0.3v46.9c0,8.9,7.2,16.1,16.1,16.1h0.1c8.9,0,16.1-7.2,16.1-16.1v-46.9h0.3   c1.7,0,3-1.3,3-3v-2C-112.7,180-114,178.7-115.7,178.7L-115.7,178.7z"
      />
      <rect fill={color} x="-146.3" y="199.5" width="28.3" height="2.8" />
      <path
        fill={color}
        d="M-74.5,181.7v2h-3.3v49.9c0,7.2-5.9,13.1-13.1,13.1h-0.1c-7.2,0-13.1-5.9-13.1-13.1v-49.9h-3.3v-2H-74.5 M-74.5,178.7   h-32.9c-1.7,0-3,1.3-3,3v2c0,1.7,1.3,3,3,3h0.3v46.9c0,8.9,7.2,16.1,16.1,16.1h0.1c8.9,0,16.1-7.2,16.1-16.1v-46.9h0.3   c1.7,0,3-1.3,3-3v-2C-71.5,180-72.9,178.7-74.5,178.7L-74.5,178.7z"
      />
      <rect fill={color} x="-105.2" y="189.5" width="28.3" height="2.8" />
      <g>
        <path
          fill={color}
          d="M-127.2,230.9l-1.4-6.3h-6.5l-1.4,6.3h-4.6l6.2-25.1h6.3l6.2,25.1H-127.2z M-129.5,220.5l-1.3-5.8    c-0.1-0.4-0.3-1.2-0.5-2.7c-0.3-1.4-0.4-2.4-0.5-2.8c-0.1,1-0.3,2.1-0.6,3.2c-0.2,1.2-0.8,3.9-1.8,8.1H-129.5z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M-97.4,206h6.4c2.6,0,4.5,0.5,5.7,1.5c1.2,1,1.8,2.6,1.8,4.8c0,1.4-0.3,2.7-0.9,3.6c-0.6,1-1.5,1.6-2.6,1.8v0.2    c1.4,0.4,2.4,1,3.1,2c0.6,1,0.9,2.3,0.9,3.9c0,2.3-0.6,4-1.8,5.3c-1.2,1.3-2.9,1.9-5,1.9h-7.5V206z M-93.1,216h2.1    c1,0,1.7-0.3,2.1-0.8s0.6-1.3,0.6-2.3c0-1-0.2-1.8-0.7-2.2c-0.5-0.5-1.2-0.7-2.2-0.7h-2V216z M-93.1,219.9v7h2.3    c1,0,1.7-0.3,2.2-0.9c0.5-0.6,0.7-1.5,0.7-2.8c0-2.2-1-3.3-2.9-3.3H-93.1z"
        />
      </g>
    </g>
  </svg>
);
